import * as React from 'react';
import { AppRootData } from '../components/App/types';
const context = React.createContext<Partial<AppRootData>>({});
export const GroupsProvider = context.Provider;
export const GroupsConsumer = context.Consumer;
export default context;
